import { ResourceTypeEnum } from '@/shared/components/ui/resource-icon/resource-icon.types';

// `as const satisfies` preserves the action string literals (so a type-safe action
// union can be derived) while still validating the `entity:action` shape.
export const POLICIES = {
  [ResourceTypeEnum.BackofficeUser]: [
    'backofficeUser:*',
    'backofficeUser:createUser',
    'backofficeUser:readUser',
    'backofficeUser:updateUser',
    'backofficeUser:deleteUser',
  ],
  [ResourceTypeEnum.BackofficeUserRole]: [
    'backofficeUserRole:*',
    'backofficeUserRole:createUserRole',
    'backofficeUserRole:readUserRole',
    'backofficeUserRole:updateUserRole',
    'backofficeUserRole:deleteUserRole',
    'backofficeUserRole:linkUserRole',
    'backofficeUserRole:unlinkUserRole',
  ],
  [ResourceTypeEnum.BackofficeGroup]: [
    'backofficeGroup:*',
    'backofficeGroup:createGroup',
    'backofficeGroup:readGroup',
    'backofficeGroup:updateGroup',
    'backofficeGroup:deleteGroup',
  ],
  [ResourceTypeEnum.BackofficeTenant]: [
    'backofficeTenant:*',
    'backofficeTenant:readTenant',
    'backofficeTenant:selectTenant',
    'backofficeTenant:createTenant',
    'backofficeTenant:deleteTenant',
    'backofficeTenant:updateTenant',
    'backofficeTenant:manageTenantSubscription',
    'backofficeTenant:exportTenantBilling',
    'backofficeTenant:listTenantAuditLog',
  ],
  [ResourceTypeEnum.BackofficeEc2OrchestratorConfig]: [
    'backofficeEc2OrchestratorConfig:*',
    'backofficeEc2OrchestratorConfig:readConfig',
    'backofficeEc2OrchestratorConfig:readGlobalConfig',
    'backofficeEc2OrchestratorConfig:updateGlobalConfig',
    'backofficeEc2OrchestratorConfig:createConfig',
    'backofficeEc2OrchestratorConfig:updateConfig',
    'backofficeEc2OrchestratorConfig:deleteConfig',
  ],
} as const satisfies Record<string, readonly `${string}:${string}`[]>;
